import Table from '@components/table'
import TableActions from '@components/table/actions'
import Column from '@components/column'
import Alert from '@commons/popups/alert'
import { GeneralSetting } from '@apis'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import SectionHeading from '@commons/headings/section'
import { useNavigate } from 'react-router-dom'
const FaqList = () => {
  const { data: faqs } = useSelector((state: any) => state.faqs)
  const [deleteInfo, setDeleteInfo] = useState({
    visible: false,
    id: null,
    loading: false,
  })
  const navigate = useNavigate()
  const columns = [
    {
      title: 'Question',
      key: 'question',
      render: (item) => {
        const parse = JSON.parse(item?.value)
        return parse?.question
      },
    },
    {
      title: 'Answer',
      key: 'answer',
      render: (item) => {
        const parse = JSON.parse(item?.value)
        return parse?.answer
      },
    },
    {
      title: 'Category',
      key: 'category',
      render: (item) => {
        const parse = JSON.parse(item?.value)
        return parse?.category
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (item) => {
        return (
          <TableActions
            hasView={false}
            onClickEdit={() => {
              navigate('.', {
                state: item,
              })
            }}
            onClickDelete={() => {
              setDeleteInfo({
                visible: true,
                id: item?.id,
                loading: false,
              })
            }}
          />
        )
      },
    },
  ]

  const fetchData = async () => {
    await GeneralSetting.getByGroup({
      id: 'faqs',
      state: 'faqs',
    }).catch(() => {})
  }

  const removeData = async () => {
    setDeleteInfo({
      ...deleteInfo,
      loading: true,
    })
    await GeneralSetting.remove({
      id: deleteInfo?.id,
      state: 'faqs',
    }).catch(() => {})

    setDeleteInfo({
      ...deleteInfo,
      visible: false,
      loading: false,
    })
  }

  useEffect(() => {
    if (!faqs?.length) {
      fetchData()
    }
  }, [])

  return (
    <Column>
      <Column styleColumn="margin-bottom:30px;">
        <SectionHeading title="Faqs List" />
      </Column>
      <Table columns={columns} data={faqs} />
      <Alert
        visible={deleteInfo?.visible}
        loading={deleteInfo?.loading}
        onClickOk={removeData}
        onClickClose={() => {
          setDeleteInfo({
            visible: false,
            id: null,
            loading: false,
          })
        }}
      />
    </Column>
  )
}

export default FaqList
